import api from '../baseApi.js'
import { byName, unwrap } from '../helpers.js'

export const examSessionsApi = {
  getAll: () => api.get('/exam-sessions').then(unwrap).then(byName),
  getOne: (id) => api.get(`/exam-sessions/${id}`).then(unwrap),
  create: (data) => api.post('/exam-sessions', data).then(unwrap),
  update: (id, data) => api.put(`/exam-sessions/${id}`, data).then(unwrap),
  remove: (id) => api.delete(`/exam-sessions/${id}`).then(unwrap),
}
